<template>
  <div>
    <p class="cm-mg-p-wzd">
      1. {{ $t('production.rejection_category_data_info') }}
    </p>
    <hr />
    <div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.code')}: *`"
            v-model="model.code"
            name="common_words.code"
            v-validate="modelValidations.code"
            :error="getError('common_words.code', true)"
            placeholder="..."
          >
          </fg-input>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <fg-input
            type="text"
            :label="`${$t('common_words.name')}: *`"
            v-model="model.name"
            name="common_words.name"
            v-validate="modelValidations.name"
            :error="getError('common_words.name', true)"
            placeholder="..."
            @blur="convertUppercase(model.name)"
          >
          </fg-input>
        </div>
        <select-component
          :rowClass="`col-12 col-md-6 col-lg-4`"
          :isMultiple="true"
          :dataOptions="crops"
          :requireClass="`required-crop`"
          @onChange="handleChangeSelected"
          :labelSelect="`${$t('common_words.select_crops')}: *`"
          modelName="crop_ids"
          :initialSelection="model.crop_ids"
        />
        <div class="col-12">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, convertFirstLetterUppercase } from 'src/util/Util.js';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  data() {
    return {
      model: {
        id: null,
        crop_ids: [],
        name: null,
        code: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
        code: {
          required: true,
        },
      },
      crops: [],
      categories: [],
      businessesInitial: [],
    };
  },

  computed: {},

  mixins: [MixinPermissions, MixinForm, MixinLoading, MixinValidations],
  methods: {
    convertUppercase(nameCategory) {
      const name = convertFirstLetterUppercase(nameCategory);
      this.model.name = name;
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((responseInputs) => {
          const cropIds = this.model.crop_ids;
          if (isset(cropIds) && Array.isArray(cropIds) && cropIds.length) {
            const found = this.crops.filter((c) => cropIds.includes(c.id));
            this.$set(this.model, 'crop', found.map((f) => f.name).join(', '));
          } else {
            this.$set(this.model, 'crop', null);
          }

          this.$emit('on-validated', this.model);

          return responseInputs;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(this.model.crop_ids)) {
            return this.validationInputsRequired('crop');
          } else if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else return true;
        });
    },
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, name, code, crops } = editForm;

      const cropIds = Array.isArray(crops) ? crops.map((c) => c.id) : [];
      this.model = {
        ...this.model,
        isEdit: true,
        id: id,
        crop_ids: cropIds,
        code,
        name,
      };

      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },

  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('farms/crops')
        .then((response) => {
          this.crops = this.concatAll(response.data.data);
          if (!sessionStorage.getItem('editForm') && this.crops.length == 1) {
            this.model.crop_ids.push(this.crops[0].id);
          }
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },
};
</script>
<style></style>
